function Bahamas({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_590)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FFDA44"/>
  <path d="M9.73908 10.4348H31.0047C28.7441 4.342 22.8793 0 15.9999 0C11.5816 0 7.58202 1.79119 4.68677 4.68681L9.73908 10.4348Z" fill="#338AF3"/>
  <path d="M9.73908 21.5654H31.0047C28.7441 27.6582 22.8793 32.0002 15.9999 32.0002C11.5816 32.0002 7.58202 30.2091 4.68677 27.3134L9.73908 21.5654Z" fill="#338AF3"/>
  <path d="M4.68628 4.68604C-1.56209 10.9344 -1.56209 21.0651 4.68628 27.3135C7.26834 24.7315 9.75165 22.2482 16 15.9998L4.68628 4.68604Z" fill="black"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Bahamas;
